// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as EventTracker from "../../../../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as ProgressModal from "../../../../../../../../library/components/generic-components/components/ProgressModal.bs.js";
import * as CityVehicleCmp from "../reusable-components/CityVehicleCmp.bs.js";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as SidebarHeaderCmp from "../reusable-components/SidebarHeaderCmp.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as AllocationDashboardUtils from "../../../utils/AllocationDashboardUtils.bs.js";
import * as CreateMandatoryCampaignForm from "./create-campaigns-form/CreateMandatoryCampaignForm.bs.js";
import * as CrmControlledReleaseContext from "../../../../../../../../library/data-source/controlled-rollout/context/CrmControlledReleaseContext.bs.js";
import * as PreviewMandatoryCampaignCmp from "./preview-campaign/PreviewMandatoryCampaignCmp.bs.js";
import * as AllocationDashboardDataMachine from "../../../../../app/repo/AllocationDashboardDataMachine.bs.js";
import * as MandatoryAllocationCampaignsCmp from "./campaign-details/MandatoryAllocationCampaignsCmp.bs.js";

function getInitialPreviewState(vehicle, geo_region, user_name) {
  return {
          vehicle: vehicle,
          geo_region: geo_region,
          created_by: user_name,
          created_on: undefined,
          campaignName: undefined,
          startDate: undefined,
          startTime: undefined,
          endDate: undefined,
          endTime: undefined,
          allocationRadiusManual: undefined,
          allocationRadiusAutomatic: undefined,
          allocationRadiusDelta: undefined,
          thresholdDistance: undefined,
          dryRunRatio: undefined,
          dryRunDelta: undefined,
          maxDryRunManual: undefined,
          maxDryRunAutomatic: undefined,
          maxDryRunDelta: undefined
        };
}

function calculateEndDateTime(campaigns_list, preview_data) {
  var start_time = preview_data.startTime;
  var scheduled_and_active_campaigns = List.sort((function (c1, c2) {
          if (Timestamp$Catalyst.isBefore(c1.effective_from, c2.effective_from)) {
            return 1;
          } else {
            return 0;
          }
        }), Belt_List.keep(campaigns_list.campaigns, (function (campaign) {
              if (campaign.campaign_status === /* Active */0) {
                return true;
              } else {
                return campaign.campaign_status === /* Scheduled */1;
              }
            })));
  var start_date_time = {
    contents: undefined
  };
  Belt_List.forEach(scheduled_and_active_campaigns, (function (campaign) {
          var foundSome = start_date_time.contents;
          if (foundSome !== undefined || !Timestamp$Catalyst.isBefore(start_time, campaign.effective_from)) {
            return ;
          } else {
            start_date_time.contents = Caml_option.some(campaign.effective_from);
            return ;
          }
        }));
  return start_date_time.contents;
}

function generateMandatoryCampaignPayload(preview_data) {
  return {
          geo_region_id: preview_data.geo_region.id,
          vehicle_id: preview_data.vehicle.vehicle_id,
          campaign_name: Belt_Option.getExn(preview_data.campaignName),
          start_date_time: Timestamp$Catalyst.toFloat(Belt_Option.getExn(preview_data.startTime)),
          filters: {
            allocation_radius: {
              auto: AllocationDashboardUtils.AllocationDashboardUtils.convertKmsToMeters(Belt_Option.getExn(preview_data.allocationRadiusAutomatic)),
              manual: AllocationDashboardUtils.AllocationDashboardUtils.convertKmsToMeters(Belt_Option.getExn(preview_data.allocationRadiusManual)),
              radius_delta: Belt_Option.map(preview_data.allocationRadiusDelta, AllocationDashboardUtils.AllocationDashboardUtils.convertKmsToMeters)
            },
            dry_run: {
              threshold: AllocationDashboardUtils.AllocationDashboardUtils.convertKmsToMeters(Belt_Option.getExn(preview_data.thresholdDistance)),
              ratio: Belt_Option.getExn(preview_data.dryRunRatio),
              radius_delta: Belt_Option.map(preview_data.dryRunDelta, (function (value) {
                      return AllocationDashboardUtils.AllocationDashboardUtils.convertKmsToMeters(value);
                    }))
            },
            maps_distance: {
              manual: AllocationDashboardUtils.AllocationDashboardUtils.convertKmsToMeters(Belt_Option.getExn(preview_data.maxDryRunManual)),
              auto: AllocationDashboardUtils.AllocationDashboardUtils.convertKmsToMeters(Belt_Option.getExn(preview_data.maxDryRunAutomatic)),
              radius_delta: Belt_Option.map(preview_data.maxDryRunDelta, AllocationDashboardUtils.AllocationDashboardUtils.convertKmsToMeters)
            }
          }
        };
}

function CreateMandatoryCampaignCmp(Props) {
  var vehicle = Props.vehicle;
  var geo_region = Props.geo_region;
  var campaigns_list = Props.campaigns_list;
  var dispatch = Props.dispatch;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return /* Edit */0;
      });
  var setFormStage = match$1[1];
  var user = React.useContext(CrmControlledReleaseContext.context);
  var match$2 = React.useState(function () {
        return getInitialPreviewState(vehicle, geo_region, user.adminBetaAccessData.admin.name);
      });
  var updatePreviewData = match$2[1];
  var preview_data = match$2[0];
  var match$3 = React.useState(function () {
        return /* Init */0;
      });
  var setRequestStatus = match$3[1];
  var filtered_campaign = Belt_List.keep(campaigns_list.campaigns, (function (campaign) {
          return campaign.campaign_status === /* Active */0;
        }));
  var match$4 = Belt_List.length(filtered_campaign);
  var active_mandatory_campaign = match$4 !== 0 ? (
      match$4 !== 1 ? ErrorUtils$Catalyst.raiseError("CreateMandatoryCampaign.res", "Multiple Mandatory Campaigns found for a given city-vehicle", "Vehicle: " + vehicle.vehicle.vehicle_type + " City: " + geo_region.name) : Belt_List.headExn(filtered_campaign)
    ) : ErrorUtils$Catalyst.raiseError("CreateMandatoryCampaign.res", "Active Mandatory Campaign not found for given city-vehicle", "Vehicle: " + vehicle.vehicle.vehicle_type + " City: " + geo_region.name);
  React.useEffect((function () {
          var previous_data = preview_data.endTime;
          if (previous_data !== undefined) {
            var previous_data$1 = Caml_option.valFromOption(previous_data);
            var updatedEndTime = calculateEndDateTime(campaigns_list, preview_data);
            if (updatedEndTime !== undefined) {
              var isDiff = Timestamp$Catalyst.toFloat(previous_data$1) - Timestamp$Catalyst.toFloat(Belt_Option.getWithDefault(updatedEndTime, previous_data$1));
              if (isDiff === 0.0) {
                
              } else {
                Curry._1(updatePreviewData, (function (param) {
                        return {
                                vehicle: preview_data.vehicle,
                                geo_region: preview_data.geo_region,
                                created_by: preview_data.created_by,
                                created_on: preview_data.created_on,
                                campaignName: preview_data.campaignName,
                                startDate: preview_data.startDate,
                                startTime: preview_data.startTime,
                                endDate: preview_data.endDate,
                                endTime: updatedEndTime,
                                allocationRadiusManual: preview_data.allocationRadiusManual,
                                allocationRadiusAutomatic: preview_data.allocationRadiusAutomatic,
                                allocationRadiusDelta: preview_data.allocationRadiusDelta,
                                thresholdDistance: preview_data.thresholdDistance,
                                dryRunRatio: preview_data.dryRunRatio,
                                dryRunDelta: preview_data.dryRunDelta,
                                maxDryRunManual: preview_data.maxDryRunManual,
                                maxDryRunAutomatic: preview_data.maxDryRunAutomatic,
                                maxDryRunDelta: preview_data.maxDryRunDelta
                              };
                      }));
              }
            }
            
          } else {
            var endTime = calculateEndDateTime(campaigns_list, preview_data);
            if (endTime !== undefined) {
              Curry._1(updatePreviewData, (function (param) {
                      return {
                              vehicle: preview_data.vehicle,
                              geo_region: preview_data.geo_region,
                              created_by: preview_data.created_by,
                              created_on: preview_data.created_on,
                              campaignName: preview_data.campaignName,
                              startDate: preview_data.startDate,
                              startTime: preview_data.startTime,
                              endDate: preview_data.endDate,
                              endTime: endTime,
                              allocationRadiusManual: preview_data.allocationRadiusManual,
                              allocationRadiusAutomatic: preview_data.allocationRadiusAutomatic,
                              allocationRadiusDelta: preview_data.allocationRadiusDelta,
                              thresholdDistance: preview_data.thresholdDistance,
                              dryRunRatio: preview_data.dryRunRatio,
                              dryRunDelta: preview_data.dryRunDelta,
                              maxDryRunManual: preview_data.maxDryRunManual,
                              maxDryRunAutomatic: preview_data.maxDryRunAutomatic,
                              maxDryRunDelta: preview_data.maxDryRunDelta
                            };
                    }));
            }
            
          }
          
        }), [preview_data]);
  var create = function (payload) {
    Curry._1(setRequestStatus, (function (param) {
            return {
                    TAG: /* Loading */0,
                    _0: undefined
                  };
          }));
    return AllocationDashboardDataMachine.createMandatoryCampaign(payload, (function (param) {
                  Curry._1(dispatch, {
                        TAG: /* UpdateSidebarState */6,
                        opened_sidebar: undefined
                      });
                  Curry._1(dispatch, /* RefreshCampaignList */1);
                  Curry._1(setRequestStatus, (function (param) {
                          return {
                                  TAG: /* Live */1,
                                  _0: undefined
                                };
                        }));
                  Curry._1(dispatch, {
                        TAG: /* OpenSnackbar */7,
                        snackbar_message: {
                          TAG: /* Success */0,
                          _0: "Campaign Created Successfully"
                        }
                      });
                  return EventTracker.publishEvent({
                              category: "Allocation Campaign",
                              action: "Create Mandatory Allocation Campaign Success",
                              label: "Random",
                              value: undefined,
                              nonInteraction: undefined
                            });
                }), (function (error) {
                  Curry._1(dispatch, {
                        TAG: /* OpenSnackbar */7,
                        snackbar_message: {
                          TAG: /* Error */1,
                          _0: ErrorUtils$Catalyst.resolveError(error)
                        }
                      });
                  Curry._1(setRequestStatus, (function (param) {
                          return {
                                  TAG: /* Error */2,
                                  _0: error
                                };
                        }));
                  return EventTracker.publishEvent({
                              category: "Allocation Campaign",
                              action: "Create Mandatory Allocation Campaign Failure",
                              label: "Random",
                              value: undefined,
                              nonInteraction: undefined
                            });
                }), country);
  };
  var submitCTA = function (param) {
    return Curry._1(dispatch, {
                TAG: /* OpenModal */10,
                modal: {
                  isOpen: true,
                  onCancel: (function (param) {
                      return Curry._1(dispatch, /* CloseModal */3);
                    }),
                  onSubmit: (function (param) {
                      Curry._1(dispatch, /* CloseModal */3);
                      var match = preview_data.endTime;
                      if (match !== undefined) {
                        return Curry._1(dispatch, {
                                    TAG: /* OpenModal */10,
                                    modal: {
                                      isOpen: true,
                                      onCancel: (function (param) {
                                          return Curry._1(dispatch, /* CloseModal */3);
                                        }),
                                      onSubmit: (function (param) {
                                          Curry._1(dispatch, /* CloseModal */3);
                                          return create(generateMandatoryCampaignPayload(preview_data));
                                        }),
                                      title: "Campaign Overlap Found",
                                      confirm_button_title: "Yes, Proceed",
                                      cancel_button_title: "No, Cancel",
                                      modal_body: "There is already a scheduled mandatory campaign, please refer to the side panel for details. Do you want to proceed?"
                                    }
                                  });
                      } else {
                        return create(generateMandatoryCampaignPayload(preview_data));
                      }
                    }),
                  title: "Create Campaign",
                  confirm_button_title: "Yes, Proceed",
                  cancel_button_title: "No, Cancel",
                  modal_body: "You are about to create a new madatory campaign. Are you sure you wish to continue?"
                }
              });
  };
  var tmp;
  var tmp$1 = match$3[0];
  tmp = typeof tmp$1 === "number" || tmp$1.TAG !== /* Loading */0 ? null : React.createElement(ProgressModal.make, {
          isOpen: true
        });
  return React.createElement("div", {
              className: "c-create-mandatory-campaign"
            }, React.createElement(React.Fragment, undefined, match$1[0] ? React.createElement("div", {
                        className: "ald-campaign-details-sidebar-container"
                      }, React.createElement(SidebarHeaderCmp.make, {
                            preview: true,
                            campaign_name: preview_data.campaignName,
                            discard_warning_required: true,
                            dispatch: dispatch
                          }), React.createElement("div", {
                            className: "existing-campaigns-and-form-data"
                          }, React.createElement(MandatoryAllocationCampaignsCmp.make, {
                                filtered_campaings: campaigns_list.campaigns
                              }), React.createElement("div", {
                                className: "ald-sidebar-panel"
                              }, React.createElement(CityVehicleCmp.make, {
                                    vehicle_name: vehicle.vehicle.vehicle_type,
                                    geo_region: geo_region.name
                                  }), React.createElement("div", {
                                    className: "campaign-details-body"
                                  }, React.createElement(PreviewMandatoryCampaignCmp.make, {
                                        preview_data: preview_data,
                                        active_mandatory_campaign: active_mandatory_campaign,
                                        setFormStage: setFormStage,
                                        submitCTA: submitCTA
                                      }))))) : React.createElement("div", {
                        className: "ald-campaign-details-sidebar-container"
                      }, React.createElement(SidebarHeaderCmp.make, {
                            preview: true,
                            campaign_name: undefined,
                            discard_warning_required: true,
                            dispatch: dispatch
                          }), React.createElement("div", {
                            className: "existing-campaigns-and-form-data"
                          }, React.createElement(MandatoryAllocationCampaignsCmp.make, {
                                filtered_campaings: campaigns_list.campaigns
                              }), React.createElement("div", {
                                className: "ald-sidebar-panel"
                              }, React.createElement(CityVehicleCmp.make, {
                                    vehicle_name: vehicle.vehicle.vehicle_type,
                                    geo_region: geo_region.name
                                  }), React.createElement("div", {
                                    className: "create-campaign-body"
                                  }, React.createElement("div", undefined, React.createElement(CreateMandatoryCampaignForm.make, {
                                            state: preview_data,
                                            setFormStage: setFormStage,
                                            updatePreviewData: updatePreviewData,
                                            dispatch: dispatch
                                          }))))))), React.createElement(React.Fragment, undefined, tmp));
}

var make = CreateMandatoryCampaignCmp;

export {
  getInitialPreviewState ,
  calculateEndDateTime ,
  generateMandatoryCampaignPayload ,
  make ,
  
}
/* react Not a pure module */
